export enum ETypes {
  DIGITAL = 1,
  SERVICE = 2,
  PHYSICAL = 3,
  TICKET = 4,
}
export interface ITypes {
  DIGITAL: 1;
  SERVICE: 2;
  PHYSICAL: 3;
  TICKET: 4;
}

export interface ICurrency {
  id: number;
  name: string;
  code: 'BRL' | 'USD' | 'EUR' | 'GBP';
}

export enum EChargeType {
  SINGLE = 'N',
  SUBSCRIPTION = 'A',
  OTHER = 'L',
  FREE = 'G',
}

export interface IChargeType {
  SINGLE: 'N';
  SUBSCRIPTION: 'A';
  OTHER: 'L';
  FREE: 'G';
}

export interface IBasic {
  title: string;
  type: keyof ITypes;
  categories: number[];
  description: string;
  image: any;
}

export interface IDetails {
  prelaunch: boolean;
  launch_date: string;
  has_expiration_date: boolean;
  expiration_date: string;
  alternative_url: string;
  friendly_name: string;
  author_name: string;
  program_content: string;
}

export interface ISupportRefund {
  support_email: string;
  refund_days: number;
}

export interface IPayment {
  charge_type: keyof IChargeType;
  currency_type: ICurrency;
  price: number;
}
